import { render, staticRenderFns } from "./itemDispatchCreateModal.vue?vue&type=template&id=5aac1189&"
import script from "./itemDispatchCreateModal.vue?vue&type=script&lang=ts&"
export * from "./itemDispatchCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports